import { TextboxControlWithDatePicker } from "@/Common/Components/Inputs/TextboxControlWithDatePicker";
import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import { DateTimeWithPrecision } from "@/Common/Models/DateTimeWithPrecision";
import { LifeStageDatePrecisionEnum } from "@/Common/Models/LifeStageDatePrecisionEnum";

import styles from "./LastDateReviewedDatePicker.module.scss";

interface LastDateReviewedDatePickerProps {
    id: string;
    dataCy: string;
    showDatePicker?: boolean;
    encounterDate: Date;
    dateValue: DateTimeWithPrecision | null;
    lastReviewedDate: Date | null;
    onChange: (newDate: DateTimeWithPrecision | null) => void;
}

export function LastDateReviewedDatePicker({
    id,
    dataCy,
    encounterDate,
    dateValue,
    lastReviewedDate,
    onChange,
    showDatePicker
}: Readonly<LastDateReviewedDatePickerProps>): JSX.Element {
    const { getText } = useTranslation();
    return (
        <div className={styles.notesDatePickerContainer}>
            {showDatePicker && (
                <TextboxControlWithDatePicker
                    id={`date-${id}`}
                    key={`date-${id}`}
                    expectedPrecisionMinimum={LifeStageDatePrecisionEnum.Day}
                    dateValue={dateValue?.value}
                    textValue={dateValue?.text}
                    onChange={onChange}
                    maxDate={encounterDate}
                    width={120}
                    dataCy={dataCy}
                />
            )}
            {lastReviewedDate && (
                <div className={styles.lastReviewed}>
                    {`${getText("Flowsheets_CheckboxDateRowLabel_LastReviewed")}: ${lastReviewedDate}`}
                </div>
            )}
        </div>
    );
}
